/* @jsx h */
import { defineComponent, h } from "vue";
import { PreferencePeriods } from "./PreferencePeriods";
import { ShiftRequests } from "./ShiftRequests";
import { TimeOffRequests } from "./TimeOffRequests";

// What the team sent in: shift claims and offers, monthly preferences, time off.
// See docs/plans/workday/staff_planning.md (phase 2).
export const RotaRequestsPage = defineComponent({
  name: "RotaRequestsPage",
  setup() {
    return () => (
      <div class="space-y-4">
        <ShiftRequests />
        <PreferencePeriods />
        <TimeOffRequests />
      </div>
    );
  },
});
